export class ClasificacionCorteOficina {
  idClasificacionCorte: number;
  nombreClasificacion: string;
  descripcionClasificacion: string;
}
